import * as types from '../actions/scansTable';

export default function setIsLoadingScansAction(isLoading) {
  return {
    type: types.SET_IS_LOADING_SCANS,
    isLoading,
  };
}
